import { render, staticRenderFns } from "./UiButton.vue?vue&type=template&id=644e4d42"
import script from "./UiButton.vue?vue&type=script&lang=ts"
export * from "./UiButton.vue?vue&type=script&lang=ts"
import style0 from "./UiButton.vue?vue&type=style&index=0&id=644e4d42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports